module.exports = __webpack_public_path__ + "img/jobImg.515b8ecb.png";